import { UseFormReturn } from 'react-hook-form';

import FormInputWrapper from 'components/input/FormInputWrapper';
import { Input } from 'components/input/Input';
import { Grid } from 'components/layout';
import { LoadTextInput } from 'pages/LoadView/LoadInformation/Components';

import { TransportProFormLoad } from '../types';

type SpecificationsSectionProps = {
  formMethods: UseFormReturn<TransportProFormLoad>;
};

export function SpecificationsSection({
  formMethods,
}: SpecificationsSectionProps) {
  const { watch } = formMethods;
  const minTemp = watch('specifications.minTempFahrenheit');
  const isHazmat = Boolean(watch('specifications.hazmat'));

  return (
    <Grid cols='1' gap='md' className='w-full mx-0'>
      <LoadTextInput name='mode' label='Mode' readOnly />
      <LoadTextInput
        name='specifications.transportType'
        label='Transport Type'
        readOnly
      />
      {isHazmat ? (
        <FormInputWrapper name='specifications.hazmat' label='Hazmat' readOnly>
          <Input readOnly value='Yes' />
        </FormInputWrapper>
      ) : null}
      <LoadTextInput
        name='specifications.serviceType'
        label='Service Type'
        readOnly
      />
      {minTemp != null ? (
        <LoadTextInput
          name='specifications.minTempFahrenheit'
          label='Temperature (°F)'
          readOnly
          inputType='number'
        />
      ) : null}
    </Grid>
  );
}
